import { render, staticRenderFns } from "./TranslationCollapsableGroup.vue?vue&type=template&id=3e3297dd&scoped=true&"
import script from "./TranslationCollapsableGroup.vue?vue&type=script&lang=js&"
export * from "./TranslationCollapsableGroup.vue?vue&type=script&lang=js&"
import style0 from "./TranslationCollapsableGroup.vue?vue&type=style&index=0&id=3e3297dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3297dd",
  null
  
)

export default component.exports